// extracted by css-extract-rspack-plugin
export default {"heading":"iv6PiAhpKFMGkCRX"};